import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  container: {
    width: '100%',
    height: 'auto',
    flexDirection: 'column',
    alignItems: 'left',
    justifyContent: 'left',
    backgroundColor: theme.palette.common.white,
    textAlign: 'justify',
  },
  CFTemplateContainer: {
    padding: theme.spacing(2, 1.8, 0, 1.6),
  },
  pageContent: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  accDetails: {
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(0),
  },
  infoIcon: {
    height: '14px !important',
  },
  link: {
    color: theme.palette.opaque.dark,
  },
  infoContainer: {
    marginLeft: theme.spacing(-2),
  },
  infoText: {
    fontSize: '12px',
  },
  btnContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingRight: theme.spacing(1.8),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
  },
}))
